import * as React from "react"
import { useEffect, useRef } from "react"
import { useSignal } from "@preact/signals-react"
import { Box } from "@mui/material"
import { AutocompleteAsyncSeeker } from "@ui-seeker/core"

import { DIPSkuInputAdornment } from "@components"
import { WEBBACK_V2_API } from "@constants"
import { brand, category, errors, haveEncodedValue, haveSkuEncodedValue, sku, skuGroup } from "@signals"


export default function DIPSku({ showAdornment=false, checkLimitSku=null, ...props}) {
	const typing = useRef(false)
	const skuOptions = useSignal([])
	const haveError = useSignal(false)
	const inputValue = useSignal("")
	const isLoading = useSignal(false)

	useEffect(() => {
		if (sku.value.length === 0) {
			errors.value = {
				...errors.value,
				sku: haveError.value ? `Max ${checkLimitSku} skus` : null,
			}
		} else {
			if (checkLimitSku !== null) {
				if (sku.value.length > checkLimitSku) errors.value = {...errors.value, sku: `Max ${checkLimitSku} skus`}

				if (!haveError.value && sku.value.length < checkLimitSku) errors.value = {...errors.value, sku: null}
			}
			if (haveError.value) {
				haveError.value = false
				errors.value = {...errors.value, sku: null}
			}
		}
	}, [haveError.value, sku.value.length, JSON.stringify(errors.value), checkLimitSku])

	return <AutocompleteAsyncSeeker
		multiple
		urlAjax={`${WEBBACK_V2_API}/master-data/sku/find`}
		filters={{ brand: brand.value, category: category.value, skuGroup: skuGroup.value || '' }}
		label="SKUs"
		placeholder="Search SKU..."
		options={skuOptions.value}
		inputValue={inputValue.value}
		error={errors.value?.sku || errors.value?.skuPricingEvo}
		value={sku.value}
		formatOptionLabel={({ label, value }) => {
			if (value === "select_all")
				return <Box borderBottom="1px solid" width={1}>
					{label}
				</Box>
			return label
		}}
		limitTags={6}
		onChange={e => {
			const newValue = e.target.value
			let finalValue = newValue
			
			if (props.multiple !== false && newValue.includes("select_all")) {
				finalValue = [
					...new Set([
						...sku.value,
						...skuOptions.value
							.filter(op => op.value !== "select_all")
							.map(op => op.value)
					])
				]
			}

			const exceedsLimit =
				checkLimitSku !== null &&
				finalValue.length > checkLimitSku &&
				sku.value.length <= finalValue.length

			haveError.value = exceedsLimit
			if (!exceedsLimit) sku.value = finalValue
			inputValue.value = ""
		}}
		onInitAjax={() => isLoading.value = true}
		onFinishAjax={options => {
			isLoading.value = false
			skuOptions.value = [
				...props.multiple !== false ? [{label: "Select All", value: "select_all"}] : [],
				...options
			]

			haveError.value = checkLimitSku !== null && options.length > checkLimitSku;

			if (skuGroup.value && !typing.current)
				if(!haveEncodedValue.value || !haveSkuEncodedValue.value){
					sku.value = options.map(({value}) => value)
				}
				haveEncodedValue.value = false
		}}
		onInputChange={(_, newInputValue, reason) => {
			if (reason !== "clear")
				typing.current = true
			inputValue.value = newInputValue
		}}
		inputProps={showAdornment ? {
			endAdornment: <DIPSkuInputAdornment skuOptions={skuOptions} isLoading={isLoading.value} />
		} : undefined}
		{...props}
	/>
}